<template>
	<div class="row">
		<div class="col-sm-12">
			<div class="card mb-3">
				<div class="row g-0">
					<div
						class="col-md-3 d-flex flex-column justify-content-evenly align-items-center overflow-hidden"
					>
						<div class="profile">
							<img
								class="user-profile round-img shadow-lg"
								:src="`${userImage.url}${user.image}`"
								alt="profile"
							/>
						</div>

						<h2 class="text-warning">
							{{ user.firstName }}
							{{ user.lastName }}
						</h2>
					</div>
					<div class="col-md-9">
						<div class="card-body">
							<table class="table table-striped table-hover">
								<tbody>
									<tr>
										<th>User Name</th>
										<td>
											{{ user.firstName }}
											{{ user.lastName }}
										</td>
									</tr>
									<tr>
										<th>Email</th>
										<td>
											{{ user.email || "-" }}
										</td>
									</tr>
									<tr>
										<th>Phone</th>
										<td>
											{{ user.phone || "-" }}
										</td>
									</tr>
									<tr>
										<th scope="row">Role</th>
										<td>{{ user?.role[0].replace(/_/gi, " ") }}</td>
									</tr>
									<tr>
										<th>Assigned Area</th>
										<td>
											{{ user.area || "-" }}
										</td>
									</tr>
									<tr>
										<th>Assigned To</th>
										<td>
											{{
												user.assignTo === null
													? "-"
													: user?.assignTo[0]?.firstName +
													  " " +
													  user?.assignTo[0]?.lastName
											}}
										</td>
									</tr>
									<tr>
										<th>Target Confirm In</th>
										<td>
											{{ user?.targetType || "-" }}
										</td>
									</tr>
									<tr>
										<th>Booking Amount Target</th>
										<td>
											{{ user.bookingTarget || "-" }}
										</td>
									</tr>
									<tr>
										<th>Enquiry Target</th>
										<td>
											{{ user.enquiryTarget || "-" }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { reactive, inject } from "vue";

	export default {
		name: "UserShow",

		setup(props) {
			const masterStore = inject("masterStore");

			const user = reactive({
				firstName: masterStore.state.data.firstName,
				lastName: masterStore.state.data.lastName,
				email: masterStore.state.data.email,
				phone: masterStore.state.data.phone,
				role: masterStore.state.data.role,
				assignTo: masterStore.state.data.assignTo,
				area: masterStore.state.data.area,
				targetType: masterStore.state.data.targetType,
				enquiryTarget: masterStore.state.data.enquiryTarget,
				bookingTarget: masterStore.state.data.bookingTarget,
				image: masterStore.state.data.image,
			});
			const userImage = reactive({
				url: process.env.VUE_APP_IMAGE_PREFIX,
			});

			return {
				user,
				userImage,
			};
		},
	};
</script>
<style scoped>
	.profile {
		height: 200px;
		width: 200px;
		border-radius: 50%;
		overflow: hidden;
	}
	.user-profile {
		width: 200px;
		height: 200px;
		border-radius: 50%;
	}
	tr th,
	td {
		padding: 0.8rem 6px;
		font-size: 1.2rem;
	}
</style>
